<highcharts-chart
   [Highcharts] = "highcharts"
   [options] = "chartOptions"
   class="donut_chart_height">
</highcharts-chart>
